module.exports = __webpack_public_path__ + "img/9788998791063.3f703ca2.jpg";